import { Typography } from "@suraasa/placebo-ui"
import React from "react"

const tableRows = [
  {
    heading: "International Teaching Skills",
    without: "Self-learned and fragmented",
    withText:
      "Comprehensive and structured training in international teaching skills",
  },
  {
    heading: "Skills Portfolio with Digital Evidence",
    without: "Less comprehensive with no evidence of skills",
    withText:
      "Comprehensive skills portfolio with attached evidence of your teaching skills",
  },
  {
    heading: "Technology Integration",
    without: "Self-taught and usually outdated",
    withText: "Training on the latest technology and AI tools",
  },
  {
    heading: "Practical Application of Learning",
    without: "Limited opportunities",
    withText:
      "Emphasis on real-world application of your knowledge through assessments and assignments.",
  },
  {
    heading: "Feedback Mechanisms",
    without: "Delayed or unavailable",
    withText: "Regular, timely feedback",
  },
  {
    heading: "Access to Resources",
    without: "Limited, potentially high costs",
    withText: "Access to high-quality, curated resources",
  },
  {
    heading: "Recognition by Educational  Authorities",
    without: "Variable recognition",
    withText:
      "Recognized by reputable educational authorities and awarding bodies",
  },
  {
    heading: "Interview Preparation",
    without: "Self-preparation with limited resources",
    withText: "Structured preparation with mock interviews and expert feedback",
  },
  {
    heading: "Job Search",
    without: "Independently searching for opportunities",
    withText:
      "Assistance with job placements and recommendation of your profile to top Schools globally",
  },
  {
    heading: "Networking",
    without: "Limited to local or personal networks",
    withText:
      "Extensive networking opportunities with global educators and community of teachers across the world.",
  },
  {
    heading: "International Faculty",
    without: "Limited access",
    withText: "Learn from international experts and faculty",
  },
]

interface TableRowProps {
  heading: string
  without: string
  withText: string
}
const TableRow: React.FC<TableRowProps> = ({ heading, without, withText }) => (
  <tr>
    <td className=" :border-gray-700 whitespace-nowrap border-b border-onSurface-200 bg-white px-6 py-4">
      <Typography
        variant="title4"
        color="common.black.200"
        className="text-wrap"
      >
        {heading}
      </Typography>
    </td>
    <td className="w-3/4 whitespace-nowrap border-b border-l border-onSurface-300 bg-onSurface-200 px-6 py-4">
      <Typography variant="body" color="common.black.200" className="text-wrap">
        {without}
      </Typography>
    </td>
    <td className=" w-3/4 whitespace-nowrap border-b border-l border-success-300 bg-success-100 px-6 py-4">
      <Typography variant="body" color="success.900" className="text-wrap">
        {withText}
      </Typography>
    </td>
  </tr>
)

const ComparisonTable = () => {
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <table className="w-full text-left sm:table-fixed">
        <thead className=" text-common-white-200">
          <tr>
            <th scope="col" className="w-1/2 bg-black px-6 py-3">
              <Typography variant="title3">Aspect of Difference</Typography>
            </th>
            <th scope="col" className="w-3/4 bg-black px-6 py-3">
              <Typography variant="title3">
                Without International Teaching Qualification
              </Typography>
            </th>
            <th scope="col" className="w-3/4 bg-black px-6 py-3">
              <Typography variant="title3">
                With International Teaching Qualification
              </Typography>
            </th>
          </tr>
        </thead>
        <tbody>
          {tableRows.map((row, index) => (
            <TableRow
              key={index}
              heading={row.heading}
              without={row.without}
              withText={row.withText}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default ComparisonTable
